import { t } from "i18next";
import { HiOutlineCheck } from "react-icons/hi";
import i18n from "src/core/configs/i18n";
export interface IProps {
  stepTwo?: boolean;
}
function StepsForBillComponent(props: IProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-row items-center justify-center">
        <div className="flex justify-center items-center rounded-full h-14 w-14 bg-mint-500">
          <HiOutlineCheck className="text-2xl text-white" />
        </div>
        <div className="bg-mint-500 h-0.5 w-[430px] mobile:w-[calc(100vw-250px)]"></div>
        <div
          className={`flex justify-center items-center rounded-full h-14 w-14 ${
            props.stepTwo ? "bg-mint-500" : "bg-white border border-[#8E98A1]"
          }`}
        >
          {props.stepTwo ? (
            <HiOutlineCheck className="text-2xl text-white" />
          ) : (
            <img src="/assets/icons/receipt-text.svg" alt="" />
          )}
        </div>
      </div>
      <div
        className={`flex flex-row ${
          i18n.language === "ar"
            ? "w-[600px] mobile:w-[calc(100vw-100px)]"
            : "w-[600px] mobile:w-[calc(100vw-80px)] mobile:ml-9 ml-8"
        }  justify-between`}
      >
        <div className="font-ar text-lg text-mint-500">
          {t("stepsForBill.component.feeDetails")}
        </div>
        <div
          className={`font-ar text-lg ${
            props.stepTwo ? "text-mint-500" : "text-[#435363]"
          }`}
        >
          {t("stepsForBill.component.invoiceAndPayment")}
        </div>
      </div>
    </div>
  );
}

export default StepsForBillComponent;
